// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2IV6d","savePackageButton":"ClientWallet_savePackageButton__1YuUV"};